import { render, staticRenderFns } from "./VTag.vue?vue&type=template&id=01b58628&"
import script from "./VTag.vue?vue&type=script&lang=js&"
export * from "./VTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VTag.vue"
export default component.exports